import SimpleAccordion from "qubCommon/Accordions/SimpleAccordion";
import "./LegalFiles.css";

const apiUrl = import.meta.env.VITE_REACT_APP_BASE_URL;

const LEGAL_FRAMEWORK = {
  2025: {
    href: "/lae-miteres/KYA.pdf",
    label: "Υπουργική Απόφαση αριθ. 7826/2025 (ΦΕΚ 2636/Β/28-05-2025)",
    title:
      "«Καθορισμός Προγραμμάτων του Λογαριασμού Αγροτικής Εστίας του ΟΠΕΚΑ (ΛΑΕ/ΟΠΕΚΑ), έτους 2025».",
  },
  2026: {
    href: "/lae-miteres/KYA-7515-2026-04-24.pdf",
    label: "Υπουργική Απόφαση αριθ. 7515/2026 (ΦΕΚ 2636/Β/24-04-2026)",
    title:
      "«Καθορισμός Προγραμμάτων του Λογαριασμού Αγροτικής Εστίας του ΟΠΕΚΑ (ΛΑΕ/ΟΠΕΚΑ), έτους 2026».",
  },
};

const PROGRAM_DETAILS = {
  5: {
    2025: {
      href: "https://opeka.gr/wp-content/uploads/2025/07/%CE%A0%CE%9B%CE%97%CE%A1%CE%9F%CE%A6%CE%9F%CE%A1%CE%99%CE%95%CE%A3-%CE%94%CE%99%CE%9A%CE%91%CE%99%CE%9F%CE%A5%CE%A7%CE%A9%CE%9D-%CE%A4%CE%A1%CE%99.-%CE%A0%CE%9F%CE%9B%CE%A5%CE%A4.-2025.-24-7-2025.pdf",
      label: "Πρόγραμμα 5: Τρίτεκνες / Πολύτεκνες Μητέρες",
      deadline: "28/07/2025 09:00 - 22/09/2025 23:59",
    },
    2026: {
      href: `${apiUrl}/documents/2026 ΟΡΟΙ ΤΡΙΤΕΚΝΕΣ-ΠΟΛΥΤΕΚΝΕΣ_ΜΕ ΑΔΑ_28.5.26.pdf`,
      label: "Πρόγραμμα 5: Χρηματικά Βοηθήματα – Βραβεία",
      deadline: "15/06/2026 15:00 - 22/07/2026 23:59",
    },
  },
  6: {
    2025: {
      href: "https://opeka.gr/wp-content/uploads/2025/11/%CE%9F%CE%A1%CE%9F%CE%99-%CE%A5%CE%A0%CE%9F%CE%A4%CE%A1%CE%9F%CE%A6%CE%99%CE%A9%CE%9D_4.11.2025.pdf",
      label:
        "Πρόγραμμα 6: Υποτροφίες Επιτυχόντων Τέκνων Πανελλαδικών Εξετάσεων",
      deadline: "10/11/2025 16:00 - 01/12/2025 23:59",
    },
    2026: {
      href: null,
      label:
        "Πρόγραμμα Χρηματικών Βραβείων/Υποτροφιών σε επιτυχόντες/ούσες μαθητές/τριες στις Πανελλαδικές Εξετάσεις 2026",
      deadline:
        "Οι αιτήσεις για τη χορήγηση της παροχής των χρηματικών βραβείων/υποτροφιών υποβάλλονται εντός αποκλειστικής προθεσμίας την Τετάρτη 16 Σεπτεμβρίου 2026 και ώρα 15:00 και λήγει την Παρασκευή 16 Οκτωβρίου και ώρα 23:59.",
    },
  },
};

const accordionTitle = (text) => (
  <span style={{ fontWeight: "bold", color: "#003476", fontSize: 18 }}>
    {text}
  </span>
);

export default function PublicProgramLegalFiles({ programNumber, year }) {
  const framework = LEGAL_FRAMEWORK[year];
  const program = PROGRAM_DETAILS[programNumber][year];
  const isProgram6For2026 = programNumber === 6 && year === "2026";

  return (
    <>
      <SimpleAccordion
        title={accordionTitle("Νομοθετικό Πλαίσιο Προγράμματος")}
        content={
          <p>
            Το πρόγραμμα και οι όροι εφαρμογής του προσδιορίζονται βάσει της{" "}
            <a
              className="ds-link small-font-size"
              href={framework.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {framework.label}
            </a>
            :
            <br />
            <strong>{framework.title}</strong>
          </p>
        }
      />
      <br />

      <SimpleAccordion
        title={accordionTitle("Πληροφορίες Δικαιούχων")}
        content={
          <p>
            {program.href ? (
              <a
                className="ds-link small-font-size"
                href={program.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {program.label}
              </a>
            ) : (
              <>
                <strong>{program.label}.</strong>
                <br />
                Αναλυτικά τους όρους του προγράμματος παροχής χρηματικών
                βραβείων/υποτροφιών μπορείτε να διαβάσετε εδώ.
              </>
            )}
          </p>
        }
      />
      {!isProgram6For2026 && <br />}

      {!isProgram6For2026 && (
        <SimpleAccordion
          title={accordionTitle("Κανόνες Επιλεξιμότητας Τέκνων Ωφελουμένων")}
          content={
            isProgram6For2026 ? (
              <div style={{ fontSize: "1rem", lineHeight: 1.6, color: "#222" }}>
                <p>
                  Δικαιούχοι της παροχής είναι δύο χιλιάδες εκατόν έξι (2.106)
                  τέκνα που είναι άμεσα ή έμμεσα (εξαρτώμενα μέλη) δικαιούχοι
                  του ΛΑΕ/ΟΠΕΚΑ, εφόσον:
                </p>
                <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                  <li style={{ marginBottom: 10 }}>
                    <strong>α)</strong> είχαν τη μαθητική ιδιότητα για το
                    σχολικό έτος 2025-2026 και
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    <strong>β)</strong> είναι άγαμα και άνεργα και
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    <strong>γ)</strong> εγγράφονται για πρώτη φορά σε δημόσιο
                    Ανώτατο Εκπαιδευτικό Ίδρυμα της ημεδαπής, έχοντας επιτύχει
                    στις πανελλαδικές εξετάσεις το έτος 2026 (ή μέσω κάθε άλλης
                    διαδικασίας που εξομοιώνεται με τις πανελλαδικές εξετάσεις
                    από το αρμόδιο Υπουργείο Παιδείας, Θρησκευμάτων και
                    Αθλητισμού).
                  </li>
                </ul>
                <p>
                  <strong>Σημειώνεται ότι:</strong>
                </p>
                <ul style={{ listStyleType: "disc", paddingLeft: 22 }}>
                  <li style={{ marginBottom: 10 }}>
                    <strong>Άμεσα μέλη</strong> λογίζονται τα τέκνα που έχουν
                    δικό τους δικαίωμα ασφάλισης ως δικαιούχοι ορφανικής
                    σύνταξης ή σύνταξης αναπηρίας (τέκνο ανίκανο για κάθε
                    εργασία), ή επιδόματος παραπληγίας-τετραπληγίας (παραπληγικό
                    επίδομα) του e-ΕΦΚΑ (ΟΓΑ).
                  </li>
                  <li>
                    <strong>Εξαρτώμενα μέλη</strong> λογίζονται τα τέκνα που
                    ασφαλίζονται έμμεσα από τον ίδιο άμεσο δικαιούχο των παροχών
                    του ΛΑΕ/ΟΠΕΚΑ, ή και τον έτερο γονέα τους, εφόσον και αυτός
                    είναι άμεσα δικαιούχος των παροχών του ΛΑΕ/ΟΠΕΚΑ.
                  </li>
                </ul>
              </div>
            ) : (
              <div style={{ fontSize: "1rem", lineHeight: 1.6, color: "#222" }}>
                <p>
                  Τα τέκνα που λαμβάνονται υπόψη πρέπει να είναι{" "}
                  <strong>άγαμα</strong> και <strong>άνεργα</strong> και:
                </p>
                <ul style={{ listStyleType: "disc", paddingLeft: 22 }}>
                  <li>
                    Να μην υπερβαίνουν το δέκατο όγδοο (18<sup>ο</sup>) έτος της
                    ηλικίας τους, ή το δέκατο ένατο (19<sup>ο</sup>) έτος εφόσον
                    συνεχίζουν τη φοίτησή τους στη μέση εκπαίδευση.
                  </li>
                  <li>
                    Να μην υπερβαίνουν το εικοστό τέταρτο (24<sup>ο</sup>) έτος,
                    εφόσον σπουδάζουν σε Ίδρυμα Ανώτατης ή Ανώτερης Εκπαίδευσης
                    στην Ελλάδα ή στο εξωτερικό, φοιτούν στο «Μεταλυκειακό έτος
                    - Τάξη Μαθητείας» των Επαγγελματικών Λυκείων (ΕΠΑ.Λ.) ή σε
                    Ινστιτούτα Επαγγελματικής Κατάρτισης (Ι.Ε.Κ.).
                  </li>
                  <li>
                    Να είναι παιδιά με ποσοστό αναπηρίας πενήντα τοις εκατό
                    (50%) και άνω, ανεξαρτήτως ηλικίας.
                  </li>
                </ul>
                <p>
                  Ως ημερομηνία συμπλήρωσης των ηλικιακών ορίων θεωρείται η{" "}
                  <strong>31η Δεκεμβρίου {year}</strong>.
                </p>
              </div>
            )
          }
        />
      )}

      <br />

      <SimpleAccordion
        title={accordionTitle("Περίοδος Υποβολής Αιτήσεων")}
        content={
          <p>
            <strong>{program.label}</strong>
            <br />
            {program.deadline}
          </p>
        }
      />
      <br />

      <SimpleAccordion
        title={accordionTitle("Επεξεργασία Προσωπικών Δεδομένων")}
        content={
          <p>
            Με την υποβολή της αίτησης συμμετοχής παρέχεται η{" "}
            <strong>συγκατάθεση προς τον ΟΠΕΚΑ</strong> για την επεξεργασία των
            προσωπικών δεδομένων τόσο του προσώπου που υποβάλλει την αίτηση όσο
            και των μελών της οικογένειάς του που περιλαμβάνονται σε αυτήν,
            καθώς και για τη λήψη ενημερώσεων μέσω email ή/και sms, αποκλειστικά
            για τους σκοπούς του προγράμματος.
          </p>
        }
      />
      <br />
    </>
  );
}
